export const LANDING_PAGE = '/';
export const BROWSE = '/browse';
export const SEARCH = '/search';
export const SIGN_IN = '/signin';

